/**
 * @generated SignedSource<<fb1cbe9ed8dc1e25b3e7de1cf5efdcd9>>
 * @relayHash 1ee15a3397489b60824c4c343fef76cf
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 67754ccdf7dac8894e90328c3b77d6a6ff681f2021688087d5a1135d1c23475a

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { RoutingMethodSelectQuery } from './RoutingMethodSelectQuery.graphql';

const node: PreloadableConcreteRequest<RoutingMethodSelectQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "67754ccdf7dac8894e90328c3b77d6a6ff681f2021688087d5a1135d1c23475a",
    "metadata": {},
    "name": "RoutingMethodSelectQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
